// src/components/SectionCard.js

import React, { useState, useContext } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { FormContext } from '../../context/FormContext';
import BaseCard from './cards/BaseCard';
import tokens from '../../theme/tokens';

function SectionCard({
  sectionName,
  originalSectionName,
  sectionKey,
  initialItem,
  renderSubCard,
  dragHandle,
  onRemove,
  onSelect,
  isSelected,
}) {
  const { formData, updateFormData } = useContext(FormContext);
  const [expanded, setExpanded] = useState(true);

  const items = formData[sectionKey] || [];

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const addItem = () => {
    const newItem = initialItem();
    const currentItems = formData[sectionKey] || [];
    const newItems = [...currentItems, newItem];
    updateFormData(sectionKey, newItems);
  };

  const removeItem = (id) => {
    const currentItems = formData[sectionKey] || [];
    const newItems = currentItems.filter(item => item.id !== id);
    updateFormData(sectionKey, newItems);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const currentItems = formData[sectionKey] || [];
    const reorderedItems = Array.from(currentItems);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);
    updateFormData(sectionKey, reorderedItems);
  };

  const displayItems = items.length === 0 && sectionKey ? [] : items;

  return (
    <BaseCard
      title={sectionName}
      isSelected={isSelected}
      onRemove={onRemove}
      onSelect={onSelect}
      dragHandle={dragHandle}
      showRemoveButton={!!onRemove}
      expanded={expanded}
      onExpandClick={handleExpandClick}
      data-section={originalSectionName}
    >
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId={sectionKey}>
          {(droppableProvided) => (
            <div {...droppableProvided.droppableProps} ref={droppableProvided.innerRef}>
              {displayItems.map((item, index) => (
                <Draggable key={item?.id || `item-${index}-${sectionKey}`} draggableId={String(item?.id || `item-${index}-${sectionKey}`)} index={index}>
                  {(draggableProvided) => {
                     if (!item?.id) {
                       console.warn(`SectionCard (${sectionKey}): Item at index ${index} is missing 'id'.`);
                     }
                     return renderSubCard({
                       item,
                       index,
                       provided: draggableProvided,
                       removeItem,
                     });
                   }
                  }
                </Draggable>
              ))}
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <Box sx={{ textAlign: 'center', mt: tokens.spacing[4] }}>
        <Tooltip title={`Add ${sectionName}`}>
          <IconButton onClick={addItem}>
            <AddCircleOutline />
          </IconButton>
        </Tooltip>
      </Box>
    </BaseCard>
  );
}

export default SectionCard;